import type { Status } from "./api";

export const STATUS_LABEL: Record<Status, string> = {
  draft: "Brouillon",
  pending: "À valider",
  review: "En révision",
  validated: "Validé",
  archived: "Archivé",
};

export function StatusBadge({ s }: { s: Status }) {
  return <span className={`badge ${s}`}>{STATUS_LABEL[s]}</span>;
}

export function fmtDate(ms: number): string {
  const d = new Date(ms);
  const today = new Date();
  const sameDay =
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate();
  if (sameDay) {
    return d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
  }
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function fmtSize(b: number | null | undefined): string {
  if (!b) return "";
  if (b < 1024) return `${b} o`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} ko`;
  return `${(b / 1024 / 1024).toFixed(1)} Mo`;
}
